const LOGO_URL = 'https://customer-assets.emergentagent.com/job_digital-asset-io/artifacts/w5ymcp91_IODX%20logo%20with%20blue%20gradient%20background.png';

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[rgba(59,130,246,0.08)]" style={{ background: '#060B1E' }}>
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <img src={LOGO_URL} alt="IODX" className="h-7 w-7 rounded-sm object-cover" />
            <span className="text-xs font-bold tracking-[0.12em] uppercase text-[#94A3B8]">
              IOD<span className="text-[#3B82F6]">X</span> &middot; IBL Elements Inc.
            </span>
          </div>
          <div className="flex items-center gap-8">
            <a href="#overview" className="text-xs text-[#94A3B8] hover:text-[#60A5FA] transition-colors tracking-wide">Overview</a>
            <a href="#market" className="text-xs text-[#94A3B8] hover:text-[#60A5FA] transition-colors tracking-wide">Market</a>
            <a href="#roadmap" className="text-xs text-[#94A3B8] hover:text-[#60A5FA] transition-colors tracking-wide">Roadmap</a>
            <a href="#contact" className="text-xs text-[#94A3B8] hover:text-[#60A5FA] transition-colors tracking-wide">Contact</a>
          </div>
          <div className="text-xs text-[#94A3B8]/50">
            &copy; {new Date().getFullYear()} IBL Elements Inc. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
